<h2 matDialogTitle>
    {{'header.info_use_service' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>

<div matDialogContent class="mt-3">
    <div class='mat-table-container info-service-using mb-4'>
        <mat-table mat-table [dataSource]='dataSource'>
            <!-- STT Column -->
            <ng-container matColumnDef='id'>
                <mat-header-cell *matHeaderCellDef
                    class='mat-header-cell-center no-col mat-cell-non-boder-right-bottom'>
                    {{'form.stt' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element'
                    class='mat-header-cell-center no-col mat-cell-non-boder-right-bottom'>
                    {{element.index + 1}}</mat-cell>
            </ng-container>

            <!-- Tên dịch vụ Column -->
            <ng-container matColumnDef='name'>
                <mat-header-cell *matHeaderCellDef style='width: 15%;  min-width: 200px; text-align: center;'
                    class='mat-header-cell-center mat-cell-non-boder-right-bottom'>
                    {{'headertable.resource_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' style='width: 15%;  min-width: 200px;' matTooltip='{{element.serviceName | translate}}'
                    class='mat-cell-non-boder-right-bottom'>
                    <span class='fix-width font-weight-bold'>{{element.serviceName | translate}}</span>
                </mat-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef='status'>
                <mat-header-cell *matHeaderCellDef class='mat-header-cell-center mat-cell-non-boder-right-bottom'
                    style='width: 10%;'>
                    {{'headertable.status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' style='width: 10%; text-align: center;'
                    matTooltip="{{(element.status === 0 ? 'form.inactive_2' : element.status === 1 ? 'form.active' : 'form.trial' )| translate}}"
                    class='mat-cell-non-boder-right-bottom'>
                    <span style='width: auto; margin: 0 auto; border-radius: 5px; padding: 3px 15px;'
                        [ngClass]="element.status == 0 ? 'inactive' : element.status == 1 ? 'active' : 'triel'"
                        class='fix-width'>{{(element.status === 0 ? 'form.inactive_2' : element.status === 1 ?
                        'form.active' : 'form.trial') | translate}}</span>
                </mat-cell>
            </ng-container>

            <!-- Số lượng khả dụng Column -->
            <ng-container matColumnDef='quantityAvailable'>
                <mat-header-cell *matHeaderCellDef class='mat-header-cell-center mat-cell-non-boder-right-bottom'
                    style='width: 10%;'>
                    {{'headertable.quantity_available' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' matTooltip='{{element.quantity}}'
                    class='mat-cell-non-boder-right-bottom number-cell-right' style='width: 10%; text-align: right;'>
                    {{element.quantity}}
                </mat-cell>
            </ng-container>

            <!-- Đơn vị -->
            <ng-container matColumnDef='unit'>
                <mat-header-cell *matHeaderCellDef class='mat-header-cell-center mat-cell-non-boder-right-bottom'
                    style='width: 10%;'>
                    {{'headertable.unit' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' matTooltip='{{element.unit | translate}}'
                    class='mat-cell-non-boder-right-bottom' style='width: 10%; text-align: right;'>
                    {{element.unit | translate}}
                </mat-cell>
            </ng-container>

            <!-- Ngày hết hạn Column -->
            <ng-container matColumnDef='endDate'>
                <mat-header-cell *matHeaderCellDef style='width: 10%;'
                    class='mat-header-cell-center mat-cell-non-boder-right-bottom'>
                    {{'headertable.end_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' style='width: 10%; text-align: center;'
                    matTooltip='{{element.expiredDate}}' class='number-cell-center mat-cell-non-boder-right-bottom'>
                    <span class='fix-width'>{{element.expiredDate}}</span>
                </mat-cell>
            </ng-container>

            <!-- Ngày khóa dịch vụ Column -->
            <ng-container matColumnDef='lockedServiceDate'>
                <mat-header-cell *matHeaderCellDef style='width: 10%;'
                    class='mat-header-cell-center'>
                    {{'headertable.locked_service_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' style='width: 10%; text-align: center;'
                    matTooltip='{{element.lockedServiceDate}}'
                    class='number-cell-center'>
                    <span class='fix-width'>{{element.lockedServiceDate}}</span>
                </mat-cell>
            </ng-container>

            <!-- Số lượt cảnh báo hết số lượng Column -->
            <!-- <ng-container matColumnDef='quantityWarning'>
                <mat-header-cell *matHeaderCellDef style='width: 15%;'
                    class='mat-header-cell-center mat-cell-non-boder-right-bottom'>
                    {{'headertable.quantity_warning' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' style='width: 15%; text-align: center;'
                    matTooltip='{{element.statusQuantityWarning}}'
                    class='number-cell-center mat-cell-non-boder-right-bottom'>
                    <span class='fix-width'>{{element.statusQuantityWarning}}</span>
                </mat-cell>
            </ng-container> -->

            <!-- Số lượt cảnh báo hết hạn Column -->
            <!-- <ng-container matColumnDef='quantityExpiredWarning'>
                <mat-header-cell *matHeaderCellDef class='mat-header-cell-center' style='width: 15%;'>
                    {{'headertable.quantity_expired_warning' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef='let element' class='number-cell-center'
                    matTooltip='{{element.statusExpiredWarning}}' style='width: 15%; text-align: center;'>
                    <span class='fix-width'>{{element.statusExpiredWarning}}</span>
                </mat-cell>
            </ng-container> -->
            <mat-header-row *matHeaderRowDef='displayedColumns; sticky: true'></mat-header-row>
            <mat-row *matRowDef='let row; columns: displayedColumns;'></mat-row>
        </mat-table>
    </div>
</div>
<mat-divider></mat-divider>
<div matDialogAction class="d-flex justify-content-center mt-3">
    <button mat-stroked-button color="primary" (click)="close()" type="button" class="mr-3">
        <mat-icon class="mr-0">cancel</mat-icon>
        <span>&nbsp;{{'form.close' | translate}}</span>
    </button>
</div>
